import { ActivityStatus, ReadingTemplateRoles } from 'infrastructure/enums';

import type { IRpmActivityCountResponse } from 'infrastructure/interfaces/i-rpm-patient-activity';

export const getActivityType = (
  activeActivityType: 'unactioned' | 'actioned',
  activeActivityStatus: 'critical' | 'normalAtRisk',
  isAgencyDoctor: boolean,
  isFullyManagedAgency: boolean,
) => {
  if (activeActivityType === 'unactioned') {
    if (isAgencyDoctor && isFullyManagedAgency) {
      return activeActivityStatus === 'critical'
        ? ActivityStatus.UnactionedCritical
        : ActivityStatus.UnactionedNormalRisk;
    }
    return ActivityStatus.Unactioned;
  }
  return ActivityStatus.Actioned;
};

export const checkCurrentTemplateRole = (isMa: boolean, isRn: boolean) => {
  if (isMa) return ReadingTemplateRoles.MedicalAssistant;
  if (isRn) return ReadingTemplateRoles.RegisterNurse;
  return null;
};

export const getCriticalIndicatorColor = (
  activityCount?: IRpmActivityCountResponse,
) => {
  if (!activityCount) return '';
  if (activityCount.critical > 0) return 'red';
  return '';
};

export const getNormalAndAtRiskIndicatorColor = (
  activityCount?: IRpmActivityCountResponse,
) => {
  if (!activityCount) return '';
  if (activityCount.risk > 0) return 'yellow';
  if (activityCount.normal > 0) return 'green';

  return '';
};
